import { render, staticRenderFns } from "./AdminEmailConfirm.vue?vue&type=template&id=00d79f13"
import script from "./AdminEmailConfirm.vue?vue&type=script&lang=js"
export * from "./AdminEmailConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports